import styled from 'styled-components';

export const StyledFloatingSubscribe = styled.div`
  position: fixed;
  width: 100%;
  padding: 1.5rem;
  background: rgba(11, 19, 103, 0.9);
  z-index: 999;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;

  .subscribe-form {
  }

  .subscribe-title {
    font-weight: 700;
    color: ${({ theme }) => theme.selection};
    text-transform: uppercase;
    font-family: "NeueMachina";
    font-size: 2rem;
  }
`;

